"use client";

import { useEffect, useSyncExternalStore } from "react";

const STORAGE_KEY = "modu:read-notice-ids";
function getReadIds(): string[] {
  if (typeof localStorage === "undefined") return [];
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) ?? "[]");
    return Array.isArray(parsed)
      ? parsed.filter((id) => typeof id === "string")
      : [];
  } catch {
    return [];
  }
}

function markRead(id: string) {
  const ids = getReadIds();
  if (ids.includes(id)) return;
  localStorage.setItem(STORAGE_KEY, JSON.stringify([...ids, id].slice(-200)));
  window.dispatchEvent(new Event("notice-read"));
}

function subscribe(callback: () => void) {
  window.addEventListener("storage", callback);
  window.addEventListener("notice-read", callback);
  return () => {
    window.removeEventListener("storage", callback);
    window.removeEventListener("notice-read", callback);
  };
}

function getSnapshot() {
  if (typeof localStorage === "undefined") return "";
  return localStorage.getItem(STORAGE_KEY) ?? "";
}

function getServerSnapshot() {
  return "";
}

export default function NoticeReadBadge({
  noticeId,
  isRecent,
  markOnMount = false,
}: {
  noticeId: string;
  isRecent: boolean;
  markOnMount?: boolean;
}) {
  const readSnapshot = useSyncExternalStore(
    subscribe,
    getSnapshot,
    getServerSnapshot,
  );
  const isNew = isRecent && !getReadIds().includes(noticeId);

  useEffect(() => {
    if (markOnMount) markRead(noticeId);
  }, [markOnMount, noticeId, readSnapshot]);

  if (!isNew) return null;

  return (
    <span className="rounded-full bg-emerald-50 px-2 py-0.5 text-[11px] text-emerald-700">
      새 글
    </span>
  );
}
